<template>
	<div class="page-header">
		<div class="page-header-container">
			<div class="overflow-hidden">
				<parallax>
					<cdn-image v-if="props.image" :src="props.image"
							   :alt="title" :ratio="props.large ? 4/2 : 6/2"
							   class="max-h-400"
							   :size="{width: '100vw'}" cover immediate>
						<slot name="image"/>
					</cdn-image>
				</parallax>
			</div>

			<div class="page-header-content-container">
				<container>
					<div class="page-header-content">
						<slot name="logo"/>
						<h1 class="page-header-title font-regular text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-primary" v-html="props.title"/>
						<div class="max-w-reading m-auto">
							<slot/>
						</div>
					</div>
				</container>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type {Image} from "@spoferan/spoferan-ts-core";

const props = defineProps<{
	title: string,
	image?: string | Image,
	large?: boolean
}>();
</script>

<style>
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
/*********************
  Inputs
**********************/
.page-header {
  width: 100%;
  display: block;
  position: relative;
}
.page-header .page-header-container {
  width: 100%;
  display: block;
  position: relative;
}
.page-header .page-header-content-container {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  box-sizing: border-box;
  padding: 16px;
  width: 100%;
}
.page-header .page-header-content-container .page-header-content {
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.1);
  padding: 32px;
  box-sizing: border-box;
  position: relative;
  color: #465050;
  background-color: #ffffff;
  margin-top: -120px;
  border-radius: 5px;
}
.page-header .page-header-content-container .page-header-content > .page-header-title, .page-header .page-header-content-container .page-header-content > .max-w-reading > .page-header-title {
  margin-bottom: 32px;
}
.page-header .page-header-content-container .page-header-content > .page-header-title:only-child, .page-header .page-header-content-container .page-header-content > .max-w-reading > .page-header-title:only-child {
  margin-bottom: 0;
}
.page-header .page-header-content-container .page-header-content p {
  line-height: 1.5;
}
.page-header .page-header-content-container > * {
  text-align: center;
  width: 100%;
  position: relative;
}
.page-header .page-header-content-container > .page-header-title, .page-header .page-header-content-container > .max-w-reading > .page-header-title {
  color: #465050;
  word-break: break-word;
}

@media (max-width: 767px) {
  .page-header .page-header-container {
    min-height: auto !important;
    position: relative;
    flex-direction: column;
    width: 100%;
  }
  .page-header .page-header-content-container {
    width: unset;
    padding: 30px 0 10px;
    box-shadow: none;
  }
  .page-header .page-header-content-container .page-header-content {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
    padding: 32px;
    box-sizing: border-box;
    position: relative;
    color: #465050;
    background-color: #ffffff;
    border-radius: 10px;
    margin-top: -60px;
  }
  .page-header .page-header-content-container .page-header-content > .page-header-title {
    margin-bottom: 24px;
  }
}
@media (max-width: 639px) {
  .page-header .page-header-content-container {
    width: 100%;
  }
  .page-header .page-header-content-container .page-header-content {
    padding: 16px;
  }
}
</style>